import type { BankTemplateMetadataResponse, VerboseTemplateMetadata } from '@gcv/shared';
import { action, makeAutoObservable } from 'mobx';

import { TemplateApi } from 'api';
import { getFiBankStore } from './FiBankStore';

export class FiTemplateStore {
  templates: BankTemplateMetadataResponse = {
    templates_allowed: 0,
    questionnaires_allowed: 0,
    onboarding: {},
    questionnaires: {}
  };
  activeTemplates: BankTemplateMetadataResponse = {
    templates_allowed: 0,
    questionnaires_allowed: 0,
    onboarding: {},
    questionnaires: {}
  };
  isLoadingTemplates = false;
  constructor() {
    makeAutoObservable(this);
  }

  clearStore = action(() => {
    this.templates = {
      templates_allowed: 0,
      questionnaires_allowed: 0,
      onboarding: {},
      questionnaires: {}
    };
  });

  loadTemplates = action(async () => {
    this.isLoadingTemplates = true;
    const templateApi = new TemplateApi();
    const bankStore = getFiBankStore();
    const templates = await templateApi.getBankTemplates(bankStore.bank.id, true);

    this.templates = templates;
    const onboardingWithoutArchived = Object.fromEntries(
      Object.entries(templates.onboarding || {}).filter(([, template]) => !template.archived)
    );
    const questionnairesWithoutArchived = Object.fromEntries(
      Object.entries(templates.questionnaires || {}).filter(([, template]) => !template.archived)
    );

    this.activeTemplates = {
      ...templates,
      onboarding: onboardingWithoutArchived,
      questionnaires: questionnairesWithoutArchived
    };
    this.isLoadingTemplates = false;
  });

  updateBankTemplates = action((bankTemplates: BankTemplateMetadataResponse) => {
    this.templates = bankTemplates;
  });

  updateActiveBankTemplates = action((activeTemplates: BankTemplateMetadataResponse) => {
    this.activeTemplates = activeTemplates;
  });

  updateBankTemplate = action((templateId: string, template: VerboseTemplateMetadata) => {
    this.templates.onboarding[templateId] = template;
  });
}

let templateStore: FiTemplateStore | undefined;

export function getFiTemplateStore(): FiTemplateStore {
  if (!templateStore) {
    templateStore = new FiTemplateStore();
  }

  return templateStore;
}
